<template>
  <span 
    v-show="number>0" 
    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800 dark:bg-primary-800 dark:text-primary-100"
  >
    {{ number.toLocaleString() }}
  </span>
</template>

<script setup>
defineProps({ number: Number });
</script>
